import PlayIcon from "@mui/icons-material/PlayArrow";
import { Button, IconButton, Tooltip } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

interface AutoParkButtonProps {
  onClick: () => void;
  disabled: boolean;
  disabledMessage?: string;
  compact?: boolean;
  inGroup?: boolean;
  fullWidth?: boolean;
}

export const AutoParkButton: React.FC<AutoParkButtonProps> = ({
  onClick,
  disabled,
  disabledMessage,
  compact = false,
  fullWidth = false,
}) => {
  const { t } = useTranslation();
  const button = compact ? (
    <IconButton
      color="primary"
      onClick={onClick}
      disabled={disabled}
      size="small"
      sx={{
        bgcolor: disabled ? undefined : "primary.main",
        color: disabled ? undefined : "white",
        "&:hover": {
          bgcolor: disabled ? undefined : "primary.dark",
        },
      }}
    >
      <PlayIcon />
    </IconButton>
  ) : (
    <Button
      variant="contained"
      color="primary"
      onClick={onClick}
      startIcon={<PlayIcon />}
      fullWidth={fullWidth}
      disabled={disabled}
      size="small"
    >
      {t('screens.ramp.autoPark.button.label')}
    </Button>
  );

  const defaultDisabledMessage = t('screens.ramp.autoPark.button.disabledMessage');
  const tooltipTitle = compact
    ? t('screens.ramp.autoPark.button.tooltip')
    : disabled
    ? (disabledMessage || defaultDisabledMessage)
    : "";

  if (disabled || compact) {
    return (
      <Tooltip title={tooltipTitle}>
        <span>{button}</span>
      </Tooltip>
    );
  }

  return button;
};
